module.exports = __webpack_public_path__ + "img/VideoCam.33f464b3.png";